module.exports = __webpack_public_path__ + "static/retail-tile-image-v2-92d72fd0fde30aea7020399bc62b5af5.jpg";